import React from 'react'

import QuestionSection from '../QuestionSection/QuestionSection'
import imageSection from './result-white.svg'

const data = {
  subtitle:
    'Thanks for sharing a bit about your health. We’ve used your answers to gather some health recommendations for you.',
  imageSection,
  title: 'results',
  buttonLabel: 'Find out my results',
  addition: 'Almost there!'
}

const Result = ({
  onSectionProceed,
  shouldBackButtonExist,
  onBackClick,
  loading
}) => {
  return (
    <QuestionSection
      data={data}
      onSectionProceed={onSectionProceed}
      shouldBackButtonExist={shouldBackButtonExist}
      onBackClick={onBackClick}
      loading={loading}
      mbd={10}
      smallerText
    />
  )
}

export default Result
